<template>
    <div>
        <v-row >
            <v-col cols="12" md="6" >
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Code</th>
                            <td>{{ value ? value.code : null }}</td>
                        </tr>
                        <tr>
                            <th>Date</th>
                            <td>{{ value ? value.date : null}}</td>
                        </tr>
                        <tr>
                            <th>State</th>
                            <td>
                                <PStatus :state="value.state" v-if="value"/>
                            </td>
                        </tr>
                        <tr>
                            <th>Purchase Order</th>
                            <td>
                                <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder" style="cursor: pointer">
                                {{ value && value.purchase_order ?  value.purchase_order.code : null}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Supplier</th>
                            <td>{{ value && value.purchase_order && value.purchase_order.supplier ? value.purchase_order.supplier.display_name : null}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Account</th>
                            <th>Dimension</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, i) in lines" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{ l.item }}</td>
                            <td>{{ l.quantity }} {{ l.measure_unit }}</td>
                            <td>{{ l.ledger_account }}</td>
                            <td>{{ l.dimension }}</td>
                            <td>{{ l.notes }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Notes</th>
                            <td>{{value ? value.notes : null}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Created By</th>
                            <td>
                                <span v-if="value.created_by">
                                    {{value.created_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{value.created_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Updated By</th>
                            <td>
                                <span v-if="value.updated_by">
                                    {{value.updated_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Updated At</th>
                            <td>{{value.updated_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {formatNumber} from './../../utils/accounting';
import PStatus from './../common/PStatus';

export default {
    name: "GeneralReceipt",
    components: {
        PStatus
    },
    props: {
        value: Object
    },
    methods: {
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        showPurchaseOrder() {
            let purchaseOrderId = this.value && this.value.purchase_order ? this.value.purchase_order.id : null;
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: purchaseOrderId } });
        }
    },
    computed: {
        lines() {
            if(!this.value.lines) return [];
            return this.value.lines.map(line => ({
                ...line,
                item: `${line.item.code} - ${line.item.name}`,
                measure_unit: line.measure_unit ? line.measure_unit.abbreviation : null,
                ledger_account: line.ledger_account ? line.ledger_account.display_name : null,
                dimension: line.dimension ? line.dimension.name : null,
            }))
        }
    },
}
</script>

<style>

</style>